<script setup>
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: 'wrench',
  },
  logo: {
    type: String,
    default: '',
  },
  hasConfig: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['configure']);

const { t } = useI18n();

const handleConfigure = () => {
  emit('configure', props.id);
};
</script>

<template>
  <div
    class="group flex items-start gap-4 p-4 bg-n-slate-white dark:bg-n-slate-900 rounded-xl border border-n-weak hover:border-n-slate-6 dark:border-n-slate-7 dark:hover:border-n-slate-6 transition-all"
  >
    <!-- 图标/Logo -->
    <div
      class="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-lg bg-n-slate-3 dark:bg-n-slate-8 overflow-hidden"
    >
      <!-- 有 logo 时显示图片 -->
      <template v-if="logo">
        <img
          :src="`/dashboard/images/integrations/${logo}.png`"
          class="w-full h-full object-cover block dark:hidden"
        />
        <img
          :src="`/dashboard/images/integrations/${logo}-dark.png`"
          class="w-full h-full object-cover hidden dark:block"
        />
      </template>
      <!-- 无 logo 时显示 icon -->
      <Icon
        v-else
        :icon="`i-lucide-${icon}`"
        class="w-5 h-5 text-n-slate-11 dark:text-n-slate-10"
      />
    </div>

    <!-- 内容 -->
    <div class="flex-1 min-w-0">
      <div class="flex items-start justify-between gap-4">
        <div class="flex-1 min-w-0">
          <h3
            class="text-sm font-medium text-n-slate-12 dark:text-n-slate-1 truncate"
          >
            {{ title }}
          </h3>
          <p
            v-if="description"
            class="mt-1 text-sm text-n-slate-10 dark:text-n-slate-4 line-clamp-2"
          >
            {{ description }}
          </p>
        </div>

        <!-- 配置按钮 -->
        <div v-if="hasConfig" class="flex-shrink-0">
          <Button
            :label="$t('PILOT.BUILTIN_TOOLS.CONFIGURE')"
            variant="outline"
            color="slate"
            size="sm"
            icon="i-lucide-settings"
            @click="handleConfigure"
          />
        </div>
      </div>

      <!-- 标签 -->
      <div class="flex items-center gap-2 mt-3">
        <span
          class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-n-slate-3 dark:bg-n-slate-8 text-n-slate-11 dark:text-n-slate-10"
        >
          {{ $t('PILOT.BUILTIN_TOOLS.TYPE.BUILTIN') }}
        </span>
      </div>
    </div>
  </div>
</template>
